module.exports = __webpack_public_path__ + "static/SteeringServo-8628f1a7cfba3e831757da8edb106333.jpg";